import React, { useRef, useCallback, useState, useEffect, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import {Button, Modal, DataGrid} from '@maxis/components';
import useFetch from '@maxis/client-logic/hooks/useFetch';
import { shallow } from 'zustand/shallow';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { setLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import { findSelectedMenu } from '@maxis/client-logic/utils/menuUtil';
import { LOCAL_STORAGE_KEYS } from '@maxis/client-logic/constants/enumerates';
import useSSE from '@maxis/client-logic/hooks/useSse';
import _ from 'lodash';
import { useToast } from '@maxis/client-logic/hooks/useToast';
import NotificationItem from '@/pages/System/Popup/NotificationItem';
import moment from 'moment';

const AlarmPopup = React.forwardRef((props, ref) => {
    const { notificationInfo } = useToast();
    const refAlimPopup = useRef();
    const { request } = useFetch();
    const navigate = useNavigate();
    const MAX_ALARM_COUNT = 50;
    const [alarmData, setAlarmData] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const refAlarmCnt = useRef(0);
    const { setSelectedMenu, setSelectedTopMenu } = useBoundStore((state) => state.menu, shallow);
    const useGrid1Ref = useRef();

    const callbackSseData = useCallback(
        _.debounce((data) => {
            if (props?.callBackAction) {
                props?.callBackAction(data);
            }
        }, 500),
        []
    );

    const updateGridDataDebounced = useCallback(
        _.debounce((data) => {
            controls.grid.dataGrid.current?.setDataBinding(data);
        }, 500),
        []
    );

    const { eventSourceRef } = useSSE('1234', {
        onMessage: (event) => {
            setAlarmData((prevData) => {
                const newAlarm = {
                    IDX: prevData.length + 1,
                    MESSAGE: JSON.parse(event.data) || { message: '', time: '' },
                };
                const updatedData = [...prevData.slice(-MAX_ALARM_COUNT + 1), newAlarm];
                // const newNotification = {
                //     title: "알림",
                //     date: moment(newAlarm.MESSAGE.time).format('YYYY-MM-DD HH:mm:ss'),
                //     message: newAlarm.MESSAGE.message,
                // };
                // setNotifications((prev) => [...prev, newNotification]);

                notificationInfo(newAlarm.MESSAGE.message);

                return updatedData;
            });
        },
    });

    const controls = {
        grid: {
            dataGrid: useGrid1Ref,
            columns: [
                {
                    binding: 'IDX',
                    align: 'center',
                    width: 80,
                    isButton: true,
                    isButtonColor: 'roundRed',
                },
                { binding: 'MESSAGE', width: '*', align: 'left' },
            ],
        },
        onRowClick: () => {
            const row = controls.grid.dataGrid.current?.getSelectedRow();
            if (row) {
                popupFunctions.onMenuClick(row);
            }
        },
    };

    useEffect(() => {
        updateGridDataDebounced(alarmData);
        callbackSseData(alarmData);
    }, [alarmData, updateGridDataDebounced]);

    const popupFunctions = {
        showPopup: (position) => {
            refAlimPopup.current?.showPopup(position);
        },
        closePopup: () => {
            refAlimPopup.current?.closePopup();
        },
        setAllRead: () => {
            props.updateCallBack();
        },
        settingMenu: (pathname) => {
            const { selectedTopMenu, selectedMenu } = findSelectedMenu([], pathname);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, selectedMenu?.menuId);
            if (selectedTopMenu) {
                setSelectedTopMenu(selectedTopMenu);
            }
            if (selectedMenu) {
                setSelectedMenu(selectedMenu);
            }
        },
        onMenuClick: (d) => {
            // if (d && d.ROUTING_PATH) {
            //     popupFunctions.settingMenu(d.ROUTING_PATH);
            //     navigate(import.meta.env.VITE_PUBLIC_URL + d.ROUTING_PATH);
            //     popupFunctions.closePopup();
            // }
        },
    };

    React.useImperativeHandle(ref, () => ({
        openPopup(cnt, position) {
            refAlarmCnt.current = cnt;
            popupFunctions.showPopup(position);
        },
        bindingGrid(data, callBack) {
            const searchNotifications =data.map((x)=> {
                return {title: x.TITLE, date: x.TIME, message: x.MESSAGE}
            })
            setNotifications(searchNotifications);

            if (callBack > '') callBack(this);
        },
    }));

    return (
        <Modal
            ref={refAlimPopup}
            defaultTitle={'나의 알림'}
            closeBtnEvent={popupFunctions.closePopup}
            defaultWidth="350px"
            defaultHeight="60%"
            showFooter={true}
            isResizable={false}
            isDraggable={false}
            backDropBg={false}
            className={'whiteHeader alarmPopup arrorRight30'}
            padding={'0px'}
            headerBtns={{deleteButtonLabel: '모두읽음', buttonType: 'default', colorType:'default-outline', iconType: 'btn_apply',delBtnEvent: () => popupFunctions.setAllRead()}}
        >
            <div className="roundDivTotal">{refAlarmCnt.current}</div>
            <div className="listGridDiv">
                {notifications.map((item, index) => (
                    <NotificationItem
                        key={index}
                        title={item.title}
                        date={item.date}
                        message={item.message}
                    />
                ))}

                {/*<DataGrid*/}
                {/*    ref={controls.grid.dataGrid}*/}
                {/*    columns={controls.grid.columns}*/}
                {/*    allowAddNew={false}*/}
                {/*    onRowClick={controls.onRowClick}*/}
                {/*/>*/}
            </div>
        </Modal>
    );
});

export default AlarmPopup;
